import { useMutation } from '@tanstack/react-query'
import { toast } from 'sonner'

import { useApi } from '@fortem-monorepo/react-spa'

export const useWhitelistListsailMutation = () => {
  const api = useApi()

  return useMutation({
    mutationFn: () => api.account.saveLightsailIP(),
    onSuccess: () => {
      toast.success('Successfully added new IP')
    },
  })
}
